import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import ReactMarkdown from "react-markdown";
import Gdpr from "@edaz/edazkit/Gdpr";
import replaceLinkHost from "utils/replaceLinkHost";
import GDPRViewModel from "../../../viewModels/common/gdpr/GDPRViewModel";
import { registerView } from "@frui.ts/views";

const GdprSection: FunctionComponent<{
  vm: GDPRViewModel;
}> = observer(({ vm }) => {
  const tg = (code: string) => vm.localizationService.translateGeneral(`gdpr.${code}`);

  return (
    <Gdpr
      toggle={vm.toggleGdpr}
      showLabel={tg("show")}
      hideLabel={tg("hide")}
      gdpr={
        <ReactMarkdown linkTarget={"_blank"} className="markdown">
          {replaceLinkHost(vm.message)}
        </ReactMarkdown>
      }
      isVisible={vm.gdprVisible}
    />
  );
});

registerView(GdprSection, GDPRViewModel);
